import { Marker } from '@/map/domain/entities/map.types';

/**
 * Generate a stable key for markers comparison based on ID and position
 */
export const generateMarkersKey = (markers: Marker[]): string => {
  return markers.map((m) => `${m.id}:${m.position.lat},${m.position.lng}`).join('|');
};

/**
 * Check if two marker arrays have the same content (by ID and position)
 */
export const markersContentEqual = (prev: Marker[], next: Marker[]): boolean => {
  if (prev.length !== next.length) return false;
  return generateMarkersKey(prev) === generateMarkersKey(next);
};
